import { colorsPalette, shadows } from '../../../styles/colors';
import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const agreeButtonCss = css(typography.effra14Link, {
  fontWeight: fontWeights.medium,
  minWidth: 186,
  width: 'auto',
  [MediaQueries.mdAndUp]: {
    marginLeft: 24,
  },
  [MediaQueries.xl]: {
    marginLeft: 41,
  },
});

export const cookieBannerWrapperCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  [MediaQueries.mdAndUp]: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const linkCss = css(typography.effra16, {
  color: colorsPalette.white,
  marginLeft: 2,
  position: 'relative',
  textDecoration: 'none',
  '&:after': {
    position: 'absolute',
    bottom: -1,
    left: 0,
    content: '""',
    height: 1,
    width: '100%',
    borderBottom: `1px solid ${colorsPalette.grey80}`,
  },
  [MediaQueries.mdAndUp]: {
    marginLeft: 7,
  },
});

export const mainTextCss = css(typography.effra18, {
  color: colorsPalette.grey40,
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const spacerCss = css({
  bottom: 0,
  boxShadow: shadows.shadow80,
  color: colorsPalette.white,
  left: 0,
  position: 'fixed',
  right: 0,
  zIndex: 3,
  padding: 24,
  [MediaQueries.xl]: {
    paddingRight: 41,
    paddingLeft: 80,
  },
});
